import moment from "moment";

export const infiniteDate = date =>
  date === "0001-01-01T00:00:00Z" || date === "0001-01-01";
export const formatDate = date =>
  date && !infiniteDate(date) ? moment(date).format("DD MMM YYYY") : "-";
export const formatTime = date =>
  date && !infiniteDate(date) ? moment(date).format("HH:mm") : "-";
export const formatDateTime = date =>
  date && !infiniteDate(date) ? moment(date).format("DD MMM YYYY, HH:mm") : "-";
export const formatMonth = date =>
  date && !infiniteDate(date) ? moment(date).format("MMM") : "-";
export const formatMonthYear = date =>
  date && !infiniteDate(date) ? moment(date).format("MMM YYYY") : "-";
export const formatPeriodDate = (startDate, endDate) => {
  const invalidDate =
    !startDate || !endDate || infiniteDate(startDate) || infiniteDate(endDate);
  return !invalidDate
    ? `${formatDate(startDate)} - ${formatDate(endDate)}`
    : "-";
};
export const formatPeriodMonthYear = (startDate, endDate) => {
  const invalidDate =
    !startDate || !endDate || infiniteDate(startDate) || infiniteDate(endDate);
  return !invalidDate
    ? `${formatMonthYear(startDate)} - ${formatMonthYear(endDate)}`
    : "-";
};
export const formatPeriodMonth = (startDate, endDate) => {
  const invalidDate =
    !startDate || !endDate || infiniteDate(startDate) || infiniteDate(endDate);
  return !invalidDate
    ? `${formatMonth(startDate)} - ${formatMonth(endDate)}`
    : "-";
};
export const formatPayloadDate = date =>
  date && !infiniteDate(date) ? moment(date).format("YYYY-MM-DD") : "";
export const formatPayloadTimezone = date =>
  date && !infiniteDate(date)
    ? moment(date).format("YYYY-MM-DDTHH:mm:ssZ")
    : "";

export const parsePeriod = period => {
  if (!period || typeof period !== "string") return [null, null];

  const [startDateStr, endDateStr] = period.split(" - ").map(str => str.trim());

  return [moment(startDateStr), moment(endDateStr)];
};
export const formatPeriodFromString = period => {
  const [startDate, endDate] = parsePeriod(period);
  return formatPeriodDate(startDate, endDate);
};
export const parsePeriodMonthYear = period => {
  if (!period || typeof period !== "string") return [null, null];

  const [startDateStr, endDateStr] = period.split(" - ").map(str => str.trim());

  return [moment(startDateStr, "MM YYYY"), moment(endDateStr, "MM YYYY")];
};
export const formatPeriodMonthYearFromString = period => {
  const [startDate, endDate] = parsePeriodMonthYear(period);
  return formatPeriodMonthYear(startDate, endDate);
};
export const convertSecondsToDate = seconds => {
  return seconds
    ? moment("00:00:00", "HH:mm:ss").add(seconds, "seconds")
    : null;
};
export const convertDateToSeconds = time => {
  return time ? moment.duration(time.format("HH:mm:ss")).asSeconds() : 0;
};
export const getDatePickerMonth = date => date.month() + 1;
export const setDatePickerMonth = date => moment(date, "MM");
export const getDatePickerYear = date => date.year();
export const setDatePickerYear = date => moment(date, "YYYY");
export const setFormatPayloadDate = date => moment(date, "YYYY-MM-DD");

export default {
  infiniteDate,
  formatDate,
  formatTime,
  formatDateTime,
  formatMonth,
  formatMonthYear,
  formatPeriodMonth,
  formatPeriodMonthYear,
  getDatePickerMonth,
  setDatePickerMonth,
  getDatePickerYear,
  setDatePickerYear,
  setFormatPayloadDate,
  formatPayloadTimezone,
  parsePeriod,
  formatPeriodFromString,
  parsePeriodMonthYear,
  formatPeriodMonthYearFromString,
  convertDateToSeconds,
  convertSecondsToDate,
};
